module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('div', {
    staticClass: "fade-transition ng-scope",
    attrs: {
      "ng-view": ""
    }
  }, [_c('section', {
    staticClass: "content-header ng-scope"
  }, [_c('h1', [_vm._v("Entidades")]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": _vm.breadcrumb
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "box-header with-border",
    attrs: {
      "ssm-lte-loading": "cmptSimpleRegisterEntityForm",
      "ng-hide": "$ctrl.entity.status === 'PENDENTE_APROVACAO'  ||  $ctrl.entity.status === 'COMPLETO' || $ctrl.entity.status =='INCOMPLETO'"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-lg-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.processos.simplifiedNumber),
      expression: "processos.simplifiedNumber"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
    attrs: {
      "id": "processo",
      "name": "processo"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.processos, "simplifiedNumber", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.escolhido]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.processos), function(processo) {
    return _c('option', {
      domProps: {
        "value": processo
      }
    }, [_vm._v(_vm._s(processo.simplifiedNumber))])
  })], 2)])]), _vm._v(" "), (_vm.procSelecionado) ? _c('section', {
    staticClass: "content ng-scope"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "ng-scope ng-isolate-scope",
    attrs: {
      "ng-if": "show.grid"
    }
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body",
    attrs: {
      "id": "dadosCadastrais"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "frmCommonRegister",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "col-md-7 col-lg-6",
    attrs: {
      "id": "cadastroJuri"
    }
  }, [_c('fieldset', [_c('legend', [_vm._v("Dados da entidade:")]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Razão social')
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-4 col-md-3",
    attrs: {
      "for": "nome"
    }
  }, [_vm._v("Razão social:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidade.companyName),
      expression: "entidade.companyName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:1|max:255'),
      expression: "'required|min:1|max:255'"
    }],
    ref: "Razão social",
    staticClass: "form-control",
    attrs: {
      "name": "Razão social",
      "type": "text"
    },
    domProps: {
      "value": (_vm.entidade.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entidade, "companyName", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('Razão social')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Razão Social é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('CNPJ')
    }
  }, [_c('label', {
    ref: "CNPJ",
    staticClass: "control-label col-sm-4 col-md-3",
    attrs: {
      "for": "CNPJ"
    }
  }, [_vm._v("CNPJ:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:14|max:14'),
      expression: "'required|min:14|max:14'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "CNPJ",
      "type": "text",
      "mask": "NN.NNN.NNN/NNNN-##",
      "tokens": _vm.$cnpjTokens
    },
    model: {
      value: (_vm.entidade.cnpj),
      callback: function($$v) {
        _vm.$set(_vm.entidade, "cnpj", $$v)
      },
      expression: "entidade.cnpj"
    }
  }), _vm._v(" "), (_vm.errors.first('CNPJ')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo CNPJ é obrigatório')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('cnpjExpeditionTime')
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-4 col-md-3",
    attrs: {
      "for": "cnpjExpeditionTime"
    }
  }, [_vm._v("Expedição CNPJ:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "cnpjExpeditionTime",
    attrs: {
      "name": "cnpjExpeditionTime",
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": true,
      "placeholder": "__ /__ /____",
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.entidade.cnpjExpeditionTime),
      callback: function($$v) {
        _vm.$set(_vm.entidade, "cnpjExpeditionTime", $$v)
      },
      expression: "entidade.cnpjExpeditionTime"
    }
  }), _vm._v(" "), (_vm.errors.first('cnpjExpeditionTime')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Expedição do CNPJ é obrigatório')))]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Nome fantasia')
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-4 col-md-3",
    attrs: {
      "for": "Nome fantasia"
    }
  }, [_vm._v("Nome fantasia:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidade.businessName),
      expression: "entidade.businessName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:1|max:255'),
      expression: "'required|min:1|max:255'"
    }],
    ref: "Nome fantasia",
    staticClass: "form-control",
    attrs: {
      "name": "Nome fantasia",
      "type": "text"
    },
    domProps: {
      "value": (_vm.entidade.businessName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entidade, "businessName", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('Nome fantasia')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Nome fantasia é obrigatório')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('fieldset', [_c('legend', [_vm._v("Contato:")]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-7",
    class: {
      'has-error': _vm.errors.first('Telefone')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4"
  }, [_vm._v("Telefone: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8",
    attrs: {
      "name": "Telefone"
    }
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Telefone",
      "type": "text",
      "mask": ['(##) ####-####', '(##) #####-####']
    },
    model: {
      value: (_vm.entidade.contact.phone),
      callback: function($$v) {
        _vm.$set(_vm.entidade.contact, "phone", $$v)
      },
      expression: "entidade.contact.phone"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('Telefone')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-7",
    class: {
      'has-error': _vm.errors.first('email')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4"
  }, [_vm._v("E-mail:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8",
    attrs: {
      "name": "email"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidade.email),
      expression: "entidade.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.entidade.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entidade, "email", $event.target.value)
      }, function($event) {
        _vm.entidade.email = $event.target.value.toLowerCase()
      }]
    }
  })]), _vm._v(" "), (_vm.errors.first('email')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('email')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(2), _vm._v(" "), _c('endereco', {
    attrs: {
      "entEnderecos": _vm.entidade.address
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(3), _vm._v(" "), _c('dirigentes', {
    attrs: {
      "entDirigentes": _vm.entidade.chiefs,
      "name": "dirigentes"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('upload-documentos', {
    attrs: {
      "propDocumentos": _vm.entidade.documents,
      "documentTypes": _vm.docs,
      "documentosObrigatorios": _vm.docs
    }
  })], 1)])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('g-button-moema', {
    attrs: {
      "color": "success",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.conclui()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Concluir")]), _vm._v(" "), _c('g-button-moema', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.salva()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Salvar")]), _vm._v(" "), _c('g-button-moema', {
    attrs: {
      "color": "warning",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Voltar à lista")])], 1)])])])])])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-caret-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Processo: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-caret-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cadastro da Entidade: Simplificado")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Endereço:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Dirigentes:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Documentos Upload")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-406d7d7b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastro/entidade/EntidadeSimplificado.vue
// module id = 1923
// module chunks = 1